import "../shared/standalone.css"
import Kindle from "../shared/kindle.js"

import m from "mithril"
import Weather from "./weather-view.js"

document.redraw = function(flashNow) {
  m.redraw();
  Kindle.refreshScreen(flashNow);
}
document.addEventListener("DOMContentLoaded", function() {
  var root = document.getElementById("root")
  m.mount(document.body, Weather)
});

